import React, { Component } from "react"
import PropTypes from "prop-types"

import isFeatureEnabled from "shared/featureflags/helperFunctions"

import { enumValueSort } from "shared/search/containers/Filter/Filters"
import { enumGenericFilter, searchifySelectGenericFilter } from "shared/search/containers/Filter/FilterCreators"

import { ElectionCycleSelect } from "app/static/frontend/selects/containers/PieSelect"

export class ElectionTypeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "electionTypeFilter",
        filterKey: "election_type__in",
        enumItems: DjangIO.app.events.types.ElectionType.region_supported_items(),
        displayKey: "name",
        sortBy: enumValueSort,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const ElectionCycleFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
ElectionCycleFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
ElectionCycleFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "electionCycleFilter",
    filterKey: "election_cycles",
    dataTypeLabel: "Election Cycle",
    selectComponent: ElectionCycleSelect,
}
